<template>
  <div style="text-align: center">
    <t-pagination-mini :size="option.attribute.size" :layout="option.attribute.layout" @change="jumpChange"/>
  </div>
</template>

<script>
export default {
  name: "cpt-jumper",
  props: {option: Object, current: Object},
  created() {
    this.autoJump(this.option.attribute)
  },
  methods:{
    autoJump(attr){
      const that = this;
      if(attr.autoSwitch){
        setTimeout(()=>{
          that.jumpChange({trigger:attr.trigger})
        },attr.timeout*1000)
      }
    },
    jumpChange(context){
      console.log(context,'context')
      this.$emit("clickHandler",this.option.interaction, context.trigger, context.trigger,'cpt-jumper',context.trigger)
    }
  }
}
</script>

<style scoped>

</style>
